import * as React from 'react';
import { Label } from 'task-manager/TaskFilters.styles';
import { ArrayParam, useQueryParams } from 'use-query-params';
import { debounce } from 'lodash';

export const ClientIdsFilter = (): React.ReactElement => {
  const [query, setQuery] = useQueryParams({ clientIds: ArrayParam });
  const [clientIdsString, setClientIdsString] = React.useState<string>(
    query.clientIds?.filter(id => id !== null).join(',') || '',
  );

  const handleInputChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const cleanValue = value.replace(/\s/g, '');
    setClientIdsString(cleanValue);
    handleInputChangeEventDebounced(cleanValue);
  };

  const handleInputChangeEventDebounced = debounce((value: string) => {
    const idsArray = value ? value.split(',') : [];
    setQuery({ clientIds: idsArray }, 'pushIn');
  }, 1000);

  return (
    <span>
      <Label>Client Ids</Label>
      <input
        aria-label="client id input"
        name="clientIds"
        placeholder="eg: 4689, 85000..."
        value={clientIdsString}
        onChange={handleInputChangeEvent}
        type="text"
      />
    </span>
  );
};
